import { linearGradient } from "polished"

const colorConfigs = {
  "Gray/Flat Button Bg": "#CBD0D1",
  "Text/Dark": "#B39E9A",
  "Text/Blue": "#009A49",
  "Text/Primary Pink": "#E31C79",
  "Text/Gray": "#CBD0D1",
  "Text/Black2": "#2B2B2B",
  "Text/Gray Preview": "#606365",
  "Text/Gray Success": "#A2AAAD",
  "Gray/Card Border, Line": "#A2AAAD",
  "Text/Dark Grey": "#767676",
  "Other/Danger": "#FF0000",
  "Other/Warning": "#FAA61B",
  "Other Light/Danger": "#FCECE9",
  "Primary/Brown": "#805D57",
  "Dark Blue/Primary Text": "#009A49",
  //
  "Gray/Primary Text": "#2B2B2B",
  "Light Blue/Flat Button Background": "#E3F1F9",
  "Error/Error Text": "#FF0000",
  Success: "#009989",
  Warning: "#FAA61B",
  "Error/Line": "#FF0000",
  "Primary/Line": "#009A49",
  "Primary/Hover": "#2EB375",
  "Primary/Primary Text": "#009A49",
  "Gray/Bg": "#F5F6F6",
  "White / White": "#FFFFFF",
  "Primary/Background": "#009A49",
  "Text/Primary Text": "#000000",
  "Text/Secondary Text": "#2D2D2D",
  "Text/Line": "#7C7C7C",
  "Text/Placeholder": "#585858",
  "Text/Background": "#EAEAEA",
  "Light /Button Background": "#E7E6F9",
  "Primary/Light Hover": "#C1BFF0",
  "Text/Secondary": "#7C7C7C",
  "Approve / Waiting ": "#FFFFFF",
  "System/Warning Light": "#FFEDCC",
  "System/Error Light Hover": "#FFEBEB",
  "System/Info": "#005AE0",
  "System/Info Light": "#E0EDFF",
}

const backGroundColorGradient = linearGradient({
  colorStops: [`${colorConfigs["Primary/Primary Text"]} 81.24%`, `${colorConfigs["Primary/Hover"]} 96.64%`],
  toDirection: "213deg",
  fallback: colorConfigs["Primary/Primary Text"],
})

const colors = { colors: colorConfigs, gradient: backGroundColorGradient }

export default colors
